import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { LocalOfferOutlined } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import { Alert } from '@material-ui/lab';
import {
  ConfigManagerClient,
  CustomerClient,
  getData,
  getFirst,
  isValid,
  isValidWithoutData,
} from 'clients';
import BotClient from 'clients/BotClient';
import clsx from 'clsx';
import CartPriceFluctuationModal from 'components-v2/mocules/CartPriceFluctuationModal';
import ErrorProductsPayment from 'components-v2/mocules/ErrorProductsPayment';
import ModalListProduct from 'components-v2/mocules/ModalListProduct';
import { ButtonDefault, LinkComp } from 'components/atoms';
import CustomModal from 'components/mocules/CustomModal';
import {
  ARR_REMOVE_PRODUCT,
  BRAND_NAME,
  HTTP_STATUS,
  PAYMENT_METHOD,
  PAYMENT_METHOD_NEED_WAITING,
  TYPE_CUSTOMER_BY_COLOR,
} from 'constants/Enums';
import { ERROR_CODE_CART, ERROR_PRODUCTS } from 'constants/ErrorCart';
import { CART_NEW_GIFT_ICON } from 'constants/Images';
import { CART_URL, TERMS_URL, THANKYOU_URL, WAITING_PAYMENT } from 'constants/Paths';
import { useAuth, useCart, useProduct } from 'context';
import { useModal, useScrollIntoViewOnShow } from 'hooks';
import Cookies from 'js-cookie';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useMemo, useState } from 'react';
import { CartService } from 'services';
import AddressService from 'services/AddressService';
import { APP_CONFIG_CODE, FEATURE_SHOW_BUTTON_VERIFY_CART, LANG_DEFAULT } from 'sysconfig';
import { FormatNumber, gtag, NotifyUtils } from 'utils';
import fbpixel from 'utils/fbpixel';
import { formatCurrency, formatNumber } from 'utils/FormatNumber';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import maac from 'utils/maac';
import tiktok from 'utils/tiktok';
import { useStore } from 'zustand-lib/storeGlobal';
import useMobileV2 from 'zustand-lib/storeMobile';
import useSellers from 'zustand-lib/useSellers';
import styles from './styles.module.css';
import validateForm from './validateForm';

const ERROR_REDIRECT_TO_CART = [
  ERROR_CODE_CART.VOUCHER_CODE_INVALID,
  ERROR_CODE_CART.VOUCHER_NOT_MATCH,
  ERROR_CODE_CART.COMBO_INVALID,
  ERROR_CODE_CART.TYPE_INVALID,
  ERROR_CODE_CART.QUANTITY_INVALID,
  ERROR_CODE_CART.SKU_MISSING,
  ERROR_CODE_CART.SKU_NOT_FOUND,
  ERROR_CODE_CART.TOTAL_PRICE_NOT_MATCH,
  ERROR_CODE_CART.LIMIT_SKU,
];

// comp thanh toán , sticky
const CheckoutSticky = ({
  data,
  dataCustomer,
  onSetError,
  isMobile,
  onLoading,
  isSaveInfo,
  user,
  invoice,
  invoices = [],
  cart,
  currentAddress,
  deliveryLimitData, // savedInfo,
  translateCheckout,
}) => {
  const { t: translateAlertAction } = useTranslation('alert-action');
  const {
    redeemCode = [],
    price = 0,
    totalPrice = 0,
    deliveryMethodFee = 0,
    paymentMethodFee = 0,
    totalItemSelected = 0,
    // discount = 0,
    updateCart,
    redeemApplyResult = [],
    cartNo,
    extraFee = null,
    extraFeeNote: extraFeeNoteTh = null,
    extraFeeNoteEn = null,
    isOverWeightOrVolume,
    cartItems,
    // subPrice = 0,
    errProducts = [],
    removeCartItem,
    selectCartItem,
    removeImportant,
    totalBuymedServiceFee = 0,
    // weightFee = 0,
    // weightFeeNote: weightFeeNoteTh = null,
    // weightFeeNoteEn,
    totalWeightCalculateFee = 0,
    getState,
    cartFluctuates = [],
    isOpenPriceFluctuationModal,
    togglePriceFluctuationModal,
    confirmPriceFluctuation,
    applyPriceFluctuationFromVerify,
  } = useCart();
  const locale = Cookies.get('NEXT_LOCALE') || LANG_DEFAULT;

  // multi voucher
  const redeemRs = redeemApplyResult && redeemApplyResult?.filter((item) => !item?.autoApply);
  const autoRedeemRs =
    redeemApplyResult &&
    redeemApplyResult?.filter((item) => item?.autoApply && item?.canUse === true);

  // const { code, discountValue: discountValueManual = 0, gifts: giftsManual = null } = redeemRs || {};
  // const { discountValue: discountValueAuto = 0, gifts: giftsAuto = null } = autoRedeemRs || {};
  // const totalGiftManual = (giftsManual?.length > 0 && giftsManual.reduce((a, b) => a + b.quantity, 0)) || 0;
  // const totalGiftAuto = (giftsAuto?.length > 0 && giftsAuto.reduce((a, b) => a + b.quantity, 0)) || 0;

  const getSellerByCode = useSellers((state) => state.getSellerByCode);
  const getSellerByCodeSync = useSellers((state) => state.getSellerByCodeSync);
  const { handleRedCustomer } = useAuth();
  const debt = useStore((state) => state.getDebt());
  const appConfig = useStore((state) => state.appConfig);
  const setAppConfig = useStore((state) => state.setAppConfig);
  const { beta } = useMobileV2();
  const { clearMapProduct } = useProduct();
  const router = useRouter();
  const [showConfirmModal, toggleConfirm] = useModal(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [checkCondition, setCheckCondition] = useState({
    checked: true,
  });

  const extraFeeNote = useMemo(
    () => (locale === 'th' ? extraFeeNoteTh : extraFeeNoteEn),
    [extraFeeNoteEn, extraFeeNoteTh, locale],
  );
  // const weightFeeNote = useMemo(() => (locale === 'th' ? weightFeeNoteTh : weightFeeNoteEn), [weightFeeNoteEn, weightFeeNoteTh, locale]);
  const customerDeliveryInfo = useMemo(
    () =>
      dataCustomer?.deliveryMethods?.find((item) => item.code === dataCustomer?.deliveryMethod) ||
      null,
    [dataCustomer],
  );
  const customerPaymentInfo = useMemo(
    () =>
      dataCustomer?.paymentMethods?.find((item) => item.code === dataCustomer?.paymentMethod) ||
      null,
    [dataCustomer],
  );

  const { district, province, ward } = currentAddress || {};
  let deliveryLimitMessage = '';
  let deliveryLimitCheck = false;

  // const needToBuy = () => {
  //   if (extraFee) {
  //     if (data.customerProvinceCode === '79' || data.customerProvinceCode === '01') return 1500000 - price;
  //     return 2000000 - price;
  //   }
  //   return 0;
  // };

  // Feature flag: chặn checkout khi hệ thống đang bảo trì (app config key ALLOW_CHECKOUT)
  // status === 0 => không cho checkout => hiển thị popup bảo trì.
  // status khác 0 (hoặc không tìm thấy config) => cho phép checkout bình thường.
  const getCheckoutBlockedFromConfig = (config = []) => {
    try {
      const item = config?.find((cfg) => cfg?.value?.key === 'ALLOW_CHECKOUT');
      const { status } = item?.value || {};
      return status === 0;
    } catch {
      return false;
    }
  };

  const handleCheckCondition = (event) => {
    setCheckCondition({ ...checkCondition, [event.target.name]: event.target.checked });
  };

  const GreenCheckbox = React.memo((props) => (
    <Checkbox classes={{ root: styles.checkbox }} color="default" {...props} />
  ));
  const GreenCheckBoxElement = (
    <GreenCheckbox
      checked={checkCondition.checked}
      onChange={handleCheckCondition}
      name="checked"
      data-test="checkbox-checkout-terms-of-use"
    />
  );
  const LabelConfirm = (
    <span className={styles.check_agree_txt}>
      {translateCheckout('i_agree_with')}
      <LinkComp href={TERMS_URL} color="#005C29" target>
        &nbsp;
        {translateCheckout('condition_of_use')}
      </LinkComp>
    </span>
  );

  const validateSubmit = (formData) => {
    try {
      validateForm(formData, onSetError, translateAlertAction);
      return true;
    } catch (error) {
      NotifyUtils.error(error.message);
      return false;
    }
  };

  const handleVerify = async () => {
    onLoading(true);
    const formValue = {
      ...data,
      ...dataCustomer,
      invoice: {
        ...invoice,
        email: data.customerEmail || dataCustomer.customerEmail,
      },
      cartNo,
    };
    Object.keys(formValue).forEach((key) => {
      if (typeof formValue[key] === 'string') formValue[key] = formValue[key].trim();
    });
    if (!validateSubmit(formValue)) {
      onLoading(false);
      return;
    }
    if (!checkCondition.checked) {
      onLoading(false);
      NotifyUtils.error(translateCheckout('message_not_agree_condition_of_use'));
      return;
    }

    // validate provinces

    const districts = await AddressService.getDistrictsByProvince(formValue.customerProvinceCode);
    if (!districts) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }

    const isExistDistrict = districts.find((item) => item.value === formValue.customerDistrictCode);

    if (!isExistDistrict) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }
    // Validate
    const dataValidate = {
      ...formValue,
      totalPrice,
      voucherCode: redeemCode[0],
      skus:
        cartItems
          ?.filter((item) => item.isSelected || item.type === 'GIFT')
          ?.map(({ sku, quantity, type }) => ({ sku, type, quantity })) || [],
    };

    const validateRs = await CartService.validateCart({ body: dataValidate });

    NotifyUtils.success(JSON.stringify(validateRs));
    BotClient.sendMesageBotOrderTh({
      message: `Test validate - ${user?.phone || ''} : ${JSON.stringify(validateRs || {})}`,
    });
    onLoading(false);
  };

  const handleSubmit = async () => {
    onLoading(true);
    clearMapProduct();
    const formValue = {
      ...data,
      ...dataCustomer,
      invoice: {
        ...invoice,
        email: invoice.email,
      },
      cartNo,
    };
    Object.keys(formValue).forEach((key) => {
      if (typeof formValue[key] === 'string') formValue[key] = formValue[key].trim();
    });
    if (!validateSubmit(formValue)) {
      onLoading(false);
      return;
    }
    if (!checkCondition.checked) {
      onLoading(false);
      NotifyUtils.error(translateCheckout('message_not_agree_condition_of_use'));
      return;
    }

    // validate provinces

    const districts = await AddressService.getDistrictsByProvince(formValue.customerProvinceCode);
    if (!districts) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }

    const isExistDistrict = districts.find((item) => item.value === formValue.customerDistrictCode);

    if (!isExistDistrict) {
      NotifyUtils.error(translateCheckout('message_not_found_ward_district'));
      onLoading(false);
      return;
    }
    // Đọc lại giỏ ngay lúc submit: sau khi khách xác nhận biến động giá, closure của hàm
    // này vẫn giữ tổng tiền cũ -> BE trả TOTAL_PRICE_NOT_MATCH.
    const { totalPrice: latestTotalPrice = totalPrice, cartItems: latestCartItems = cartItems } =
      getState() || {};

    // Validate
    const dataValidate = {
      ...formValue,
      totalPrice: latestTotalPrice,
      voucherCode: redeemCode[0],
      skus:
        latestCartItems
          ?.filter((item) => item.isSelected || item.type === 'GIFT')
          ?.map(({ sku, quantity, type }) => ({ sku, type, quantity })) || [],
    };

    const validateRs = await CartService.validateCart({ body: dataValidate });

    /* Gate biến động giá: BE trả kèm fluctuatedItems ngay trong response verify này, nên
       luồng đặt hàng không cần gọi thêm GET /cart/v2 — API có side-effect ghi cache bất đồng
       bộ, đặt sát trước lệnh xoá cart của checkout thì lệnh ghi muộn có thể tái tạo cache đã
       bị xoá => cache có cart, main DB không có.

       Xử lý TRƯỚC nhánh báo lỗi bên dưới vì giá đổi cũng chính là nguyên nhân của
       TOTAL_PRICE_NOT_MATCH. BE chỉ đính fluctuatedItems vào response Ok và
       TOTAL_PRICE_NOT_MATCH, nên các lỗi verify khác vẫn rơi xuống nhánh dưới như cũ. */
    const { fluctuatedItems = [] } = getFirst(validateRs) || {};
    if (applyPriceFluctuationFromVerify(fluctuatedItems)) {
      onLoading(false);
      return;
    }

    if (!isValidWithoutData(validateRs)) {
      // nếu voucher, giỏ hàng lỗi sẽ tự động redirect về giỏ Hàng
      // APO-1559
      if (ERROR_REDIRECT_TO_CART.includes(validateRs?.errorCode)) {
        router.replace(CART_URL);
        NotifyUtils.error(
          translateAlertAction(`message_error_cart.${validateRs?.errorCode}`) ||
            validateRs?.message ||
            translateAlertAction('message_error_checkout'),
        );
        return;
      }
      if (validateRs?.errorCode === TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER && handleRedCustomer()) {
        return;
      }
      // APO-1559
      // gom những error code về sản phẩm thành 1 thông báo
      if (ERROR_PRODUCTS.includes(validateRs?.errorCode)) {
        NotifyUtils.error(translateAlertAction('message_error_products_cart'));
        onLoading(false);
        await updateCart();
        return;
      }

      if (validateRs?.errorCode === 'ORDER_MIN_1MILION') {
        const getErrorMessage = (errorData) => {
          const defaultMessage = translateAlertAction(`message_error_cart.ORDER_MIN_1MILION`);
          try {
            const { message, messageEN } = errorData.data[0];
            if (locale === 'th') {
              return message || defaultMessage;
            }
            return messageEN || defaultMessage;
          } catch {
            return defaultMessage;
          }
        };

        NotifyUtils.error(getErrorMessage(validateRs));
      } else {
        NotifyUtils.error(
          translateAlertAction(`message_error_cart.${validateRs?.errorCode}`) ||
            validateRs?.message ||
            translateAlertAction('message_error_checkout'),
        );
      }
      onLoading(false);
      BotClient.sendMesageBotOrderTh({
        message: `TS validate error - ${user?.phone || ''}: ${JSON.stringify(validateRs || {})}`,
      });
      return;
    }

    if (
      invoices &&
      invoices.length < 10 &&
      invoice &&
      invoice.invoiceRequest &&
      invoices.findIndex((item) => item.code === invoice.code) === -1 &&
      invoices.filter(
        ({ taxCode, companyName, companyAddress }) =>
          taxCode === invoice.taxCode &&
          companyName === invoice.companyName &&
          companyAddress === invoice.companyAddress,
      )?.length === 0
    ) {
      await CustomerClient.createInvoiceInfo({ body: invoice });
    }

    const response = await CartService.checkoutCart(formValue);

    if (isValid(response)) {
      // FB event tracking purchase
      const dataOrder = getFirst(response);
      if (dataOrder) {
        fbpixel.purchase({
          value: dataOrder.totalPrice,
          num_items: dataOrder.totalQuantity,
        });

        tiktok.purchase(dataOrder);
        tiktok.completePayment(dataOrder);

        // gtag
        // lọc cartItems được chọn thanh toán
        const GATrackCart = {
          ...cart,
          cartItems: cart?.cartItems?.filter((item) => item.isSelected) || [],
        };
        // load data seller nếu chưa có bằng hàm này
        await Promise.all(
          GATrackCart?.cartItems?.map((prd) => getSellerByCode({ code: prd?.sellerCode })),
        );
        // lấy data seller từ store
        // nếu từ cart / sp là combo thì retailPrice là 1000 -> cần lấy lại giá theo cartItem
        GATrackCart.cartItems =
          GATrackCart?.cartItems?.map((prd) => ({
            ...prd,
            sellerInfo: getSellerByCodeSync({ code: prd?.sellerCode }),
            displayPrice: prd.price,
          })) || [];

        gtag.purchase(GATrackCart);

        // MAAC: bắn purchase NGAY khi tạo đơn. Nếu đợi tới trang thankyou sẽ mất event ở 2/3
        // nhánh redirect (waiting-payment và cổng thanh toán ngoài đều không qua thankyou).
        // transaction_id = orderId (mã đơn thật), KHÔNG dùng cartId như gtag.purchase — SDK
        // dedup theo transaction_id nên user F5 cũng không bị tính 2 lần.
        const maacVoucher = (cart?.redeemApplyResult || [])[0];
        maac.trackPurchase({
          orderId: dataOrder?.orderId,
          revenue: dataOrder?.totalPrice,
          shipping: cart?.deliveryMethodFee,
          coupon: maacVoucher?.canUse ? maacVoucher?.code : '',
          // cartItems ở đây đã resolve sellerInfo + fix displayPrice cho sản phẩm combo
          products: GATrackCart.cartItems,
        });
      }

      if (isSaveInfo) {
        const address = {
          code: formValue.customerAddressCode,
          name: formValue.customerName,
          phone: formValue.customerPhone,
          email: formValue.customerEmail,
          address: formValue.customerShippingAddress,
          provinceCode: formValue.customerProvinceCode,
          districtCode: formValue.customerDistrictCode,
          wardCode: formValue.customerWardCode,
          regionCode: formValue.customerRegionCode,
        };
        if (!formValue.customerAddressCode) {
          const addressResp = await CustomerClient.createAddress({ body: address });
          if (!isValid(addressResp))
            NotifyUtils.error(translateAlertAction('message_failed_save_address'));
        } else {
          const resp = await CustomerClient.updateAddress({ body: address });
          if (isValid(resp)) NotifyUtils.success(translateAlertAction('message_save_address'));
          else if (resp && resp.status === HTTP_STATUS.NotFound) {
            const addressResp = await CustomerClient.createAddress({ body: address });
            if (isValid(addressResp))
              NotifyUtils.success(translateAlertAction('message_save_address'));
            else NotifyUtils.error(translateAlertAction('message_failed_save_address'));
          } else {
            NotifyUtils.error(translateAlertAction('message_failed_save_address'));
          }
        }
      }

      setTimeout(() => {
        updateCart();
      }, 1000);
      // clear products
      clearMapProduct();
      const { orderId = '' } = response.data[0] || {};

      // redirect checkout to payment link
      if (PAYMENT_METHOD_NEED_WAITING.includes(formValue.paymentMethod)) {
        // redirect checkout to waiting payment page
        router.push(`${WAITING_PAYMENT}/${orderId}`);
      } else {
        const paymentLinkRes = await CartService.getPaymentLink({ orderId });
        if (isValid(paymentLinkRes)) {
          const { paymentUrl } = getFirst(paymentLinkRes);
          if (paymentUrl) {
            router.push(
              {
                pathname: router.pathname,
                query: { ...router.query, redirectToOrderDetail: true, orderId },
              },
              undefined,
              { shallow: true },
            );
            window.location.href = paymentUrl;
          }
        } else {
          router.push(`${THANKYOU_URL}/${orderId}`);
        }
      }
      onLoading(false);
    } else {
      if (response?.errorCode === TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER && handleRedCustomer()) {
        return;
      }
      onLoading(false);
      BotClient.sendMesageBotOrderTh({
        message: `TS checkout error - ${user?.phone}: ${JSON.stringify(response || {})}`,
      });
      NotifyUtils.error(
        translateAlertAction(`message_error_cart.${response?.errorCode}`) ||
          response?.message ||
          translateAlertAction('message_error_checkout'),
      );
      setErrorMessage(
        `${translateAlertAction('message__failed_payment')}: ${
          translateAlertAction(`message_error_cart.${response?.errorCode}`) ||
          response.message ||
          translateAlertAction('message_system_error')
        }`,
      );
      updateCart();
    }
  };

  // Lấy trạng thái cờ ALLOW_CHECKOUT mới nhất ngay tại thời điểm bấm checkout.
  // Tránh dùng appConfig đã cache từ SSR (có thể bị stale nếu admin vừa đổi status).
  // Nếu request lỗi => fallback về giá trị đã cache trong store để không chặn nhầm toàn bộ khách.
  const fetchCheckoutBlockedLatest = async () => {
    try {
      const res = await ConfigManagerClient.getAppValueByCode({ appCode: APP_CONFIG_CODE });
      if (isValid(res)) {
        const freshConfig = getData(res) || [];
        setAppConfig(freshConfig);
        return getCheckoutBlockedFromConfig(freshConfig);
      }
    } catch {
      // bỏ qua, fallback bên dưới
    }
    return getCheckoutBlockedFromConfig(appConfig);
  };

  const proceedCheckout = () => {
    if (extraFee) {
      toggleConfirm();
    } else {
      handleSubmit();
    }
  };

  // Bọc hành động checkout: nếu cờ chặn đang bật thì mở popup bảo trì thay vì tiếp tục thanh toán.
  // Gate biến động giá KHÔNG nằm ở đây mà nằm trong handleSubmit, ngay sau validateCart:
  // vừa dùng lại được request verify sẵn có (không phải load lại giỏ), vừa phủ luôn nhánh
  // đi qua modal xác nhận phụ thu (proceedCheckout -> toggleConfirm -> handleSubmit).
  const handleCheckoutClick = async () => {
    onLoading(true);
    const blocked = await fetchCheckoutBlockedLatest();
    onLoading(false);
    if (blocked) {
      setShowMaintenanceModal(true);
      return;
    }
    proceedCheckout();
  };

  // Khách chấp nhận giá mới: chốt giá rồi đặt hàng luôn, không bắt bấm lại nút thanh toán.
  const handleConfirmPriceFluctuation = async () => {
    const result = await confirmPriceFluctuation();
    if (!isValidWithoutData(result)) return;
    togglePriceFluctuationModal(false);
    proceedCheckout();
  };

  const handleBackToCart = () => {
    togglePriceFluctuationModal(false);
    router.push(CART_URL);
  };

  if (deliveryLimitData) {
    deliveryLimitData?.forEach((item) => {
      if (
        item?.wardCodes?.indexOf(ward) >= 0 ||
        item?.districtCodes?.indexOf(district) >= 0 ||
        item?.provinceCodes?.indexOf(province) >= 0
      ) {
        deliveryLimitMessage = item?.message;
        deliveryLimitCheck = true;
      }
    });
  }

  const DisplayPrice = () => (
    <div className={styles.total}>
      {FormatNumber.formatCurrency(Math.max(Math.max(totalPrice, 0), 0))}
    </div>
  );
  const DisplayPriceMobileNew = () => (
    <div className={styles.totalM}>
      <span>{translateCheckout('total_money')}</span>
      <p>{FormatNumber.formatCurrency(Math.max(totalPrice, 0))}</p>
    </div>
  );

  // del err items in cart
  const [openErrItems, toggleErrItems] = useModal();
  // card lỗi nằm dưới cùng cột thanh toán, khách không cuộn xuống sẽ không thấy
  // -> tự cuộn tới khi có sản phẩm lỗi
  const isShowErrCard = errProducts?.length > 0 && !isMobile;
  const errCardRef = useScrollIntoViewOnShow(isShowErrCard);
  const handleDeleteErrProducts = async () => {
    try {
      await errProducts?.forEach(async (item) => {
        if (ARR_REMOVE_PRODUCT.indexOf(item?.errorCode) >= 0) {
          removeCartItem(item);
        }
        if (item?.errorCode === 'MAX_QUANTITY') {
          if (item?.isImportant) {
            await removeImportant(item);
          }
          selectCartItem({
            ...item,
            isSelected: !item.isSelected,
          });
        }
      });
      NotifyUtils.success(translateAlertAction('message_remove_all_error'));
      toggleErrItems();
    } catch (error) {
      NotifyUtils.error(error.message || translateAlertAction('message_remove_all_error_fail'));
    }
    router.reload();
  };

  // translate
  // const MapExtraFee = {
  //   // need to translate to Vi
  //   vi: () => (
  //     <>
  //       <Typography>
  //         Với đơn hàng dưới 1.5 triệu đồng (TP HCM và Hà Nội) hoặc dưới 2 triệu đồng (các tỉnh khác) sẽ bị phụ phí
  //         <b> {formatCurrency(50000)}</b>.
  //       </Typography>
  //       <Typography>
  //         Bạn còn cần <b>{formatCurrency(needToBuy())}</b> để được không bị tính phụ phí. Bạn muốn tiếp tục chứ?
  //       </Typography>
  //     </>
  //   ),
  //   // need to translate to Thai
  // };

  // multi voucher
  const getTotalDiscount = (autoRedeem = [], redeem = [], buymedServiceFee = 0) => {
    let total = 0;
    const validDiscounts = {
      auto: autoRedeem?.filter(
        (child) => child.discountValue && typeof +child.discountValue === 'number',
      ),
      redeem: redeem?.filter(
        (child) => child.discountValue && typeof +child.discountValue === 'number',
      ),
    };

    if (validDiscounts.auto && validDiscounts.redeem) {
      total =
        validDiscounts.auto?.reduce((acc, cur) => acc + cur.discountValue, 0) +
        validDiscounts.redeem?.reduce((acc, cur) => acc + cur.discountValue, 0);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (validDiscounts.auto) {
        total = validDiscounts.auto?.reduce((acc, cur) => acc + cur.discountValue, 0);
      } else if (validDiscounts.redeem) {
        total = validDiscounts.redeem?.reduce((acc, cur) => acc + cur.discountValue, 0);
      } else {
        total = 0;
      }
    }

    if (buymedServiceFee > 0) {
      total += buymedServiceFee;
    }

    return total > 0 ? `-${formatCurrency(total)}` : formatCurrency(total);
  };

  const methodSubTitle = () => {
    let content = '';
    if (
      [
        PAYMENT_METHOD.TRANSFER,
        PAYMENT_METHOD.COD,
        PAYMENT_METHOD.CREDIT,
        PAYMENT_METHOD.QR_BEAM,
      ].includes(customerPaymentInfo?.code)
    ) {
      if (customerPaymentInfo?.subTitle?.length > 0) {
        content = customerPaymentInfo?.subTitle?.replace(
          '{percentage}%',
          customerPaymentInfo?.additionFeeText || '',
        );
      }
    } else if (customerPaymentInfo?.additionFeeText?.length > 0) {
      content = translateCheckout('addition_fee_text', {
        text: customerPaymentInfo?.additionFeeText || '',
      });
    }

    return content.length > 0 ? (
      <div className={styles.d_flex} style={{ paddingTop: 0, maxWidth: '60%' }}>
        <div className={styles.checkout_label_second}>{content}</div>
      </div>
    ) : (
      <></>
    );
  };

  return (
    <div className={styles.checkout_sticky}>
      <Paper className={styles.root} elevation={4}>
        {/* order information - estimate total */}
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>{translateCheckout('order_information')}</div>
          <div className={styles.checkout_content}>
            <Button
              variant="outlined"
              color="primary"
              data-test="btn-checkout-edit"
              className={styles.btn}
              onClick={() => router.push('/cart')}
            >
              {translateCheckout('edit')}
            </Button>
          </div>
        </div>
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>{translateCheckout('total_products')}</div>
          <div className={styles.checkout_content}>{formatNumber(totalItemSelected)}</div>
        </div>
        {/* <div className={styles.d_flex}>
          <div className={styles.checkout_label}>{translateCheckout('total_weight')}</div>
          <div className={styles.checkout_content}>{`${totalWeightCalculateFee} kg`}</div>
        </div> */}
        <div className={styles.d_flex}>
          <div className={styles.checkout_label}>{translateCheckout('estimated_total')}</div>
          <div className={styles.checkout_content}>{formatCurrency(price)}</div>
        </div>

        {/* fees */}
        <Divider className={styles.dividerCustom} />
        {debt?.isActive && (
          <div className={styles.d_flex}>
            <div className={styles.checkout_label}>{translateCheckout('debt_remain')}</div>
            <div className={styles.checkout_content}>{debt.balanceFormated}</div>
          </div>
        )}
        {customerDeliveryInfo && deliveryMethodFee > 0 && (
          <>
            <div className={styles.d_flex}>
              <div className={styles.checkout_label}>
                {customerDeliveryInfo?.name || translateCheckout('delivery_fee')}
              </div>
              <div className={styles.checkout_content}>{formatCurrency(deliveryMethodFee)}</div>
            </div>
            {customerDeliveryInfo?.subTitleDelivery && (
              <div className={styles.d_flex} style={{ paddingTop: 0, maxWidth: '60%' }}>
                <div className={styles.checkout_label_second}>
                  {customerDeliveryInfo.subTitleDelivery}
                </div>
              </div>
            )}
          </>
        )}
        {customerPaymentInfo && paymentMethodFee !== 0 && (
          <>
            <div className={styles.d_flex}>
              <div className={styles.checkout_label}>
                {customerPaymentInfo?.name || translateCheckout('checkout_fee')}
              </div>
              <div className={styles.checkout_content}>
                {customerPaymentInfo?.code !== PAYMENT_METHOD.CREDIT &&
                  formatCurrency(paymentMethodFee)}
              </div>
            </div>
            {customerPaymentInfo?.subTitlePayment && (
              <div className={styles.d_flex} style={{ paddingTop: 0, maxWidth: '60%' }}>
                <div className={styles.checkout_label_second}>
                  {customerPaymentInfo?.subTitlePayment}
                </div>
              </div>
            )}
            {methodSubTitle()}
          </>
        )}
        {extraFee > 0 && (
          <>
            <div className={styles.d_flex}>
              <div className={styles.checkout_label}>{translateCheckout('surcharge')}</div>
              <div className={styles.checkout_content}>{formatCurrency(extraFee)}</div>
            </div>
            {extraFeeNote?.length !== 0 && (
              <div className={styles.d_flex} style={{ paddingTop: 0, maxWidth: '60%' }}>
                <div className={styles.checkout_label_second}>{extraFeeNote}</div>
              </div>
            )}
          </>
        )}
        {/* {weightFee > 0 && (
          <>
            <div className={styles.d_flex}>
              <div className={styles.checkout_label}>{translateCheckout('excess_weight_fee')}</div>
              <div className={styles.checkout_content}>{formatCurrency(weightFee)}</div>
            </div>
            {weightFeeNote?.length !== 0 && (
              <div className={styles.d_flex} style={{ paddingTop: 0, maxWidth: '60%' }}>
                <div className={styles.checkout_label_second}>{weightFeeNote}</div>
              </div>
            )}
          </>
        )} */}

        {/* filter() luôn trả mảng mà [] là truthy, nên điều kiện cũ đúng cả khi giỏ
            không có mã nào -> hiện "-0". Phải kiểm độ dài. */}
        {(redeemRs?.length > 0 || autoRedeemRs?.length > 0 || totalBuymedServiceFee > 0) && (
          <>
            <div className={`${styles.total_redeems}  ${styles.d_flex}`}>
              <Typography className={styles.checkout_label}>
                {translateCheckout('total_discount')}
              </Typography>
              <div className={styles.checkout_content}>
                {getTotalDiscount(autoRedeemRs, redeemRs, totalBuymedServiceFee)}
              </div>
            </div>
            {autoRedeemRs &&
              autoRedeemRs.length > 0 &&
              autoRedeemRs?.map((child) => (
                <div key={child.code} className={styles.d_flex}>
                  <Box display="flex" gridGap={4}>
                    <LocalOfferOutlined fontSize="small" />
                    <Typography
                      style={{
                        color: '#A2A0A0',
                        marginLeft: '4px',
                        fontSize: '14px',
                        maxWidth: '70%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {child?.code}
                    </Typography>
                  </Box>
                  {child?.discountValue > 0 && (
                    <Typography className={clsx(styles.checkout_content, styles.break_line)}>
                      -{formatCurrency(child.discountValue)}
                    </Typography>
                  )}
                  {child.gifts?.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>
                        x
                        {child.gifts
                          ?.flat()
                          ?.reduce(
                            (accmulator, currentChild) => accmulator + currentChild?.quantity,
                            0,
                          ) || 0}
                      </Typography>
                      <ImageFallbackStatic
                        src={CART_NEW_GIFT_ICON}
                        alt="icon gift"
                        height="19"
                        width="19"
                      />
                    </div>
                  )}
                </div>
              ))}
            {redeemRs &&
              redeemRs.length > 0 &&
              redeemRs.map((child) => (
                <div key={child.code} className={clsx(styles.d_flex, styles.checkout_promo_code)}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LocalOfferOutlined fontSize="small" />
                    <span
                      style={{
                        color: '#A2A0A0',
                        marginLeft: '4px',
                        fontSize: '14px',
                        maxWidth: '70%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {child.code}
                    </span>
                  </div>
                  {child.discountValue > 0 && (
                    <div className={clsx(styles.checkout_content, styles.break_line)}>
                      {`-${formatCurrency(child.discountValue)}`}
                    </div>
                  )}
                  {child.gifts?.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontFamily: 'ggsm', marginRight: 5, color: '#000' }}>
                        x
                        {child.gifts
                          ?.flat()
                          ?.reduce(
                            (accmulator, currentChild) => accmulator + currentChild?.quantity,
                            0,
                          ) || 0}
                      </Typography>
                      <ImageFallbackStatic
                        src={CART_NEW_GIFT_ICON}
                        alt="icon gift"
                        height="19"
                        width="19"
                      />
                    </div>
                  )}
                </div>
              ))}
            {totalBuymedServiceFee > 0 && (
              <div className={styles.d_flex}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LocalOfferOutlined fontSize="small" />
                  <span style={{ color: '#A2A0A0', marginLeft: '4px', fontSize: '14px' }}>
                    {translateCheckout('buymed_payment_discount')}
                  </span>
                </div>
                <div className={styles.checkout_content}>
                  {`-${formatCurrency(totalBuymedServiceFee)}`}
                </div>
              </div>
            )}
          </>
        )}

        <Divider className={styles.dividerCustom} />
        <div style={{ margin: '12px 0' }} className={styles.d_flex}>
          <div className={styles.checkout_label} style={{ fontSize: 16 }}>
            {translateCheckout('total_money')}
          </div>
          <div className={styles.total}>{formatCurrency(Math.max(0, totalPrice))}</div>
        </div>
        <Divider className={styles.dividerCustom} />

        <div>
          <p style={{ padding: '8px 16px', color: '#000' }}>
            {translateCheckout('check_info_alert')}
          </p>
          <div className={styles.condition}>
            <FormControlLabel
              style={{ padding: '8px 16px' }}
              control={GreenCheckBoxElement}
              label={LabelConfirm}
            />
            <div className={styles.list_note}>
              <p>
                1.
                {translateCheckout('alert_cancel').replace('{BRAND_NAME}', BRAND_NAME)}
              </p>
              <p>
                2.
                {translateCheckout('alert_wrong_quantity')}
              </p>
            </div>
          </div>
        </div>

        {!isMobile && (
          <div style={{ padding: '0 16px', color: '#000' }}>
            <Tooltip title={checkCondition.checked && translateCheckout('agree_with_condition')}>
              <ButtonDefault
                disabled={
                  !checkCondition.checked ||
                  deliveryLimitCheck ||
                  isOverWeightOrVolume ||
                  (debt && debt.debtBalance <= 0)
                }
                className={clsx('payment_button', styles.continue_btn)}
                onClick={handleCheckoutClick}
                data-test="btn-checkout-payment"
              >
                {translateCheckout('checkout')}
              </ButtonDefault>
            </Tooltip>
          </div>
        )}
      </Paper>

      <div className={styles.text_right}>
        {errorMessage && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {errorMessage}
            </Alert>
          </div>
        )}
        {deliveryLimitMessage && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {deliveryLimitMessage}
            </Alert>
          </div>
        )}

        {/* // TODO: feature-debt */}
        {debt?.balance <= 0 && (
          <div className={styles.condition}>
            <Alert severity="error" style={{ marginTop: '10px', borderRadius: '8px' }}>
              {debt?.balanceMessageError}
            </Alert>
          </div>
        )}

        {FEATURE_SHOW_BUTTON_VERIFY_CART && (
          <ButtonDefault btnType="success" className={styles.checkout_btn} onClick={handleVerify}>
            {translateCheckout('check')}
          </ButtonDefault>
        )}

        {isMobile && (
          <div
            className={clsx(
              styles.sticky_checkout_bar_mobile,
              beta && styles.sticky_checkout_bar_mobileNew,
            )}
          >
            <div className={styles.fwc_container}>
              <div className={styles.flex_price}>
                {beta ? <DisplayPriceMobileNew /> : <DisplayPrice />}
              </div>
              <div>
                {/* /// TODO: feature-debt */}
                <ButtonDefault
                  disabled={
                    !checkCondition.checked ||
                    user.isQuest ||
                    deliveryLimitCheck ||
                    isOverWeightOrVolume ||
                    (debt && debt.balance <= 0)
                  }
                  btnType={beta ? 'primary' : 'warning'}
                  onClick={handleCheckoutClick}
                  classes={{
                    label: styles.label,
                    outlined: styles.outlined,
                    root: beta ? styles.mobileRoot_btn : styles.root_btn,
                  }}
                >
                  {translateCheckout('checkout')}
                </ButtonDefault>
              </div>
            </div>
          </div>
        )}
      </div>
      {isShowErrCard && (
        <div className={styles.card_err_container} ref={errCardRef}>
          <Typography className={styles.text_err_notification}>
            {translateCheckout('message_error_products_in_cart')}
            <b className={styles.delete_text} role="presentation" onClick={toggleErrItems}>
              <DeleteIcon fontSize="small" /> {translateCheckout('click_here_to_delete')}
            </b>
          </Typography>
          <ErrorProductsPayment />
        </div>
      )}
      {openErrItems && (
        <ModalListProduct
          products={errProducts}
          isShowPopupConfirm={openErrItems}
          handleClosePopup={toggleErrItems}
          handleClick={handleDeleteErrProducts}
          title={translateCheckout('confirmation')}
          content={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <>
              <Typography
                className={styles.text_content_modal}
                style={{ fontWeight: '700', marginTop: '15px' }}
              >
                {translateCheckout('message_delete_all_error_products')}
              </Typography>
              <Typography className={styles.text_content_modal} style={{ marginTop: '20px' }}>
                {translateCheckout('message_exceed_back')}
              </Typography>
            </>
          }
        />
      )}
      <CustomModal
        visible={showConfirmModal}
        onClose={toggleConfirm}
        title={translateCheckout('confirmation')}
        btnOk={translateCheckout('confirm')}
        onClickOk={handleSubmit}
        btnOnClose={translateCheckout('check_cart')}
      >
        {/* {extraFee && MapExtraFee[LANG_DEFAULT]()} */}
      </CustomModal>

      <CartPriceFluctuationModal
        visible={isOpenPriceFluctuationModal}
        onClose={() => togglePriceFluctuationModal(false)}
        onBack={handleBackToCart}
        onConfirm={handleConfirmPriceFluctuation}
        products={cartFluctuates}
        isMobile={isMobile}
        isFromCheckout
      />

      {/* Popup bảo trì: hiện khi cờ ALLOW_CHECKOUT đang bật chặn thanh toán */}
      {showMaintenanceModal && (
        <CustomModal
          visible={showMaintenanceModal}
          onClose={() => setShowMaintenanceModal(false)}
          icon={false}
          title={translateCheckout('maintenance_title')}
          content={translateCheckout('maintenance_message')}
          btnOkRender={false}
          btnCloseRender={false}
          customBtnRender={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <div style={{ textAlign: 'center' }}>
              <ButtonDefault
                btnType="primary"
                className={styles.checkout_btn}
                onClick={() => setShowMaintenanceModal(false)}
              >
                {translateCheckout('maintenance_understand')}
              </ButtonDefault>
            </div>
          }
        >
          <Box display="flex" justifyContent="center" my={2}>
            <CircularProgress size={48} thickness={4} style={{ color: '#005C29' }} />
          </Box>
        </CustomModal>
      )}
    </div>
  );
};

export default CheckoutSticky;
